<template>
    <div class="row w-100 g-0">
      <div class="col">
        <div class="h-100 position-relative card-side-img rounded-0 overflow-hidden">
          <div class="p-4 card-img-overlay auth-overlay d-flex align-items-center justify-content-center">
            <slot name="logoCenter">

            </slot>
          </div>
        </div>
      </div>
      <div class="col-md-auto d-flex">
        <div class="card auth-box-form border-0 mb-0" style="min-width: 450px;">
          <div class="card-body min-vh-100 d-flex flex-column justify-content-center">

            <div class="mt-auto text-center">
              <slot name="logoLogin">

              </slot>
              <h2 class="font-bold">Entrar</h2>

              <slot name="formLogin">

              </slot>
            </div>

            <p class="text-center text-muted mt-auto mb-0">
                <strong>Copyright</strong> sgo.fpinheiro.com &copy; {{ this.anoAtual }}
            </p>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: "BaseLogin",
  data() {
    return {
      anoAtual: new Date().getFullYear(),
    }
  }
}
</script>